import { Box, Stack, Typography } from "@mui/material";
import { CreateButton, useListContext } from "react-admin";
import useAppBarHeight from "../misc/useAppBarHeight";

type BuyerEmptyProps = {
  inline?: boolean;
  subtitle?: string;
  showActions?: boolean;
};

export const BuyerEmpty = ({
  inline = false,
  subtitle,
  showActions,
}: BuyerEmptyProps) => {
  const appbarHeight = useAppBarHeight();
  const { filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;
  const resolvedSubtitle =
    subtitle ??
    (hasFilters
      ? "Ajuste os filtros para encontrar compradores."
      : "Sua lista de compradores está vazia.");
  const resolvedShowActions = showActions ?? !hasFilters;

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      gap={3}
      sx={
        inline
          ? { py: 6 }
          : { height: `calc(100dvh - ${appbarHeight}px)` }
      }
    >
      <Box
        component="img"
        src="./img/empty.svg"
        alt="Nenhum comprador encontrado"
        sx={inline ? { width: 220, maxWidth: "80%" } : undefined}
      />
      <Stack gap={0} alignItems="center">
        <Typography variant="h6" fontWeight="bold">
          Nenhum comprador encontrado
        </Typography>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          gutterBottom
        >
          {resolvedSubtitle}
        </Typography>
      </Stack>
      {resolvedShowActions && (
        <Stack spacing={2} direction="row">
          <CreateButton variant="contained" label="Novo comprador" />
        </Stack>
      )}
    </Stack>
  );
};
